import Typography from "components/elements/Typography";
import classes from "./classes.module.scss";
import I18n from "components/materials/I18n";
import Input from "components/materials/Form/InputElement";
import DragAndDropFile from "components/materials/Form/DragAndDropFileElement";

export default function ProjectLeaderInputs() {
	return (
		<div className={classes["root"]}>
			<Typography type="p" size="large" weight="bold">
				{I18n.asset.pages.professional_space.tabs.information.project_info.project_leader}
			</Typography>

			<div className={classes["form-container"]}>
				<div className={classes["group"]}>
					<Input name="firstName" label={I18n.asset.pages.professional_space.tabs.information.project_info.first_name} className={classes["input"]} />
					<Input name="lastName" label={I18n.asset.pages.professional_space.tabs.information.project_info.last_name} className={classes["input"]} />
				</div>
				<Input name="companyName" label={I18n.asset.pages.professional_space.tabs.information.project_info.enterprise} />
				<Input name="atLeastOne" hidden />
				<DragAndDropFile
					name="leaderPicture"
					accept={["image/png", "image/jpeg", "image/webp"]}
					description={I18n.asset.pages.professional_space.tabs.information.project_info.drag_and_drop}
					label={I18n.asset.pages.professional_space.tabs.information.project_info.profile_picture}
					keyErrorName={"sha256"}
				/>
			</div>
		</div>
	);
}
